import React from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { openAppAppConversionModal } from '@lib/eventManager';
import { openDeepLink } from '@common/utils';
import WarningPopupContainer from '@components/commons/popup/container/WarningPopupContainer';

interface IAppInductionPopup {
  isShow: boolean;
  where: 'detail_comment' | 'detail_like' | 'detail_number' | 'chat_comment';
  storyName: string;
  storyId: number;
  onClose: () => void;
  deepLink: string;
}

const AppInductionPopup = ({
  isShow,
  where,
  storyName,
  storyId,
  onClose,
  deepLink,
}: IAppInductionPopup) => {
  const { t } = useTranslation();
  const router = useRouter();

  const handleContinueInAppButtonClick = () => {
    openDeepLink(router, deepLink, where === 'chat_comment');
    openAppAppConversionModal({
      where,
      story: storyName,
      storyId: String(storyId),
    });
  };

  if (!isShow) {
    return null;
  }

  return (
    <WarningPopupContainer
      title={t('common_popup_description_only_available_on_app')}
    >
      <div css={container}>
        <div className="content">
          {t(
            'common_popup_description_comment_like_properties_only_available_on_app',
          )}
        </div>
        <button className="app-button" onClick={handleContinueInAppButtonClick}>
          {t('common_popup_button_continue_on_app')}
        </button>
        <button className="web-button" onClick={onClose}>
          {where === 'chat_comment'
            ? t('common_popup_button_return_to_story')
            : t('common_popup_button_return_to_details')}
        </button>
      </div>
    </WarningPopupContainer>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Apple SD Gothic Neo';

  .content {
    margin-top: 0.5em;
    font-size: 0.95em;
    line-height: 1.25em;
    font-weight: 400;
    letter-spacing: -0.3px;
    text-align: center;
    color: ${theme.colors.gray700};
  }

  .app-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5em;
    width: 100%;
    height: 3.25em;
    cursor: pointer;
    background-color: ${theme.colors.primary500};
    color: ${theme.colors.white};
    font-weight: 700;
    line-height: 1.375em;
    border-radius: 0.5em;
    font-size: 1em;
  }

  .web-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;
    font-weight: 400;
    width: 100%;
    font-size: 0.875em;
    color: ${theme.colors.primary500};
    line-height: 1.375em;
    cursor: pointer;
  }
`;

export default AppInductionPopup;
